@if (isLoading) {
  <div class="xi-loader-container__center">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}

<ng-container *transloco="let t">
  <div class="widget-impact__container" [class.hide]="isLoading">
    @if (dataSourceNotFound) {
      <div class="text-center">
        <h1>{{ t('widgets.data-source-removed-select-another') }}</h1>
      </div>
    } @else {
      @if (!hasInvalidComparison) {
        <div class="rating-controls-wrapper">
          <ng-container
            *ngTemplateOutlet="
              ratingFieldSelectBtnTemplate;
              context: {
                $implicit: ratingFieldName,
                isDisabled: dashboard.locked || isExpansionPanelShowing,
                tooltipText: ratingFieldName,
                isBucket: false,
              }
            "
          ></ng-container>

          @if (payload?.bucketName) {
            <ng-container
              *ngTemplateOutlet="
                ratingFieldSelectBtnTemplate;
                context: {
                  $implicit: payload.bucketName,
                  isDisabled: dashboard.locked || isExpansionPanelShowing,
                  tooltipText: payload.bucketName,
                  isBucket: true,
                }
              "
            ></ng-container>
          }

          <ng-template
            #ratingFieldSelectBtnTemplate
            let-text
            let-isDisabled="isDisabled"
            let-tooltipText="tooltipText"
            let-isBucket="isBucket"
          >
            <xi-default-button
              [text]="text | truncate"
              [disabled]="isDisabled"
              buttonSize="small"
              tone="light"
              [hasAnimation]="false"
              [tooltip]="{
                text: tooltipText,
              }"
              (onClick)="onShowRatingFieldSelectorModal(isBucket)"
            ></xi-default-button>
          </ng-template>
          <xi-default-button
            [text]="ratingOptionsButtonText"
            [disabled]="dashboard.locked || isExpansionPanelShowing"
            buttonSize="small"
            tone="light"
            [hasAnimation]="false"
            (onClick)="onShowRatingOptionsModal()"
          ></xi-default-button>
        </div>

        @if (!hasData) {
          <h1>{{ t('widgets.no-data-found') }}</h1>
        }

        @if (hasData && payload.type === 'focusAreas') {
          <div class="area-wrapper" [ngClass]="{ column: widget.cols < 4 }" #tableWrapper>
            @for (area of tableDataSource.data; track area; let idx = $index) {
              <div
                class="area-item"
                [ngClass]="{ center: widget.cols > 4, column: widget.cols < 4 }"
                [matTooltip]="area | areaTooltip"
                matTooltipPosition="above"
                (click)="handleAreaClick($event, area)"
              >
                @if (area | getAreaComments: commentsByPointId() : widget.payload.commentsHidden) {
                  <div class="comment-icon-wrapper">
                    <xi-icon
                      icon="comment_filled"
                      class="comment-icon"
                      [class.selected]="selectedCommentPointId === area.label"
                      (onClick)="focusAreaCommentClicked($event, area)"
                    ></xi-icon>
                  </div>
                }
                <div class="area-content">
                  <span class="area-severity">{{ idx + 1 }}</span>
                  <span class="area-label">
                    <ng-container
                      *appMiddleEllipsize="area.labelDisplay; hideTooltip: true"
                    ></ng-container>
                  </span>
                </div>
              </div>
            }
          </div>
        } @else if (hasData) {
          <div #tableWrapper class="table-container">
            <table
              mat-table
              [dataSource]="tableDataSource"
              class="widget-impact__table mat-elevation-z0"
              matSort
              [matSortActive]="payload.sort.field"
              [matSortDirection]="payload.sort.order"
              matSortDisableClear
              [matSortDisabled]="isExpansionPanelShowing"
              (matSortChange)="onSortChanged($event)"
            >
              <ng-container matColumnDef="label">
                <th mat-header-cell *matHeaderCellDef class="table-header-feature-column">
                  <span [class.ellipsis-loader]="groupFieldsLoading">
                    {{ tableHeader }}
                  </span>
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  [matTooltip]="element | impactTooltip"
                  class="clickable-column"
                  [class.overflow-visible]="hasCellPinnedComment(element.label, 'label')"
                  (click)="openCellMenu($event, element, 'label')"
                >
                  <span>
                    {{ element.labelDisplay }}
                  </span>

                  <ng-container
                    *ngTemplateOutlet="comment; context: { $implicit: element, column: 'label' }"
                  ></ng-container>
                </td>
              </ng-container>
              <ng-container matColumnDef="left">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ leftColumnHeader }}</th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  class="clickable-column"
                  [class.overflow-visible]="
                    hasCellPinnedComment(element.label, 'left') ||
                    element.selectionState?.left?.selected
                  "
                  (click)="openCellMenu($event, element, 'left', { columnFilterType: 'left' })"
                >
                  <app-impact-table-trend-indicator
                    [value]="element.leftScore"
                  ></app-impact-table-trend-indicator>

                  <ng-container
                    *ngTemplateOutlet="comment; context: { $implicit: element, column: 'left' }"
                  ></ng-container>

                  <ng-container
                    *ngTemplateOutlet="insightPoint; context: { element, column: 'left' }"
                  ></ng-container>
                </td>
              </ng-container>
              <ng-container matColumnDef="right">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ rightColumnHeader }}</th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  [matTooltip]="element | impactTooltip"
                  class="clickable-column"
                  [class.overflow-visible]="
                    hasCellPinnedComment(element.label, 'right') ||
                    element.selectionState?.right?.selected
                  "
                  (click)="openCellMenu($event, element, 'right', { columnFilterType: 'right' })"
                >
                  <app-impact-table-trend-indicator
                    [value]="element.rightScore"
                  ></app-impact-table-trend-indicator>

                  <ng-container
                    *ngTemplateOutlet="comment; context: { $implicit: element, column: 'right' }"
                  ></ng-container>

                  <ng-container
                    *ngTemplateOutlet="insightPoint; context: { element, column: 'right' }"
                  ></ng-container>
                </td>
              </ng-container>
              <ng-container matColumnDef="change">
                <th mat-header-cell *matHeaderCellDef>
                  {{ t('widgets.change') }}
                  <xi-tool-tip-content
                    [tooltip]="{
                      text: rightColumnHeader + ' - ' + leftColumnHeader,
                    }"
                  ></xi-tool-tip-content>
                </th>
                <td mat-cell *matCellDef="let element">
                  <app-impact-table-trend-indicator
                    [value]="element.change"
                    [showTrend]="true"
                  ></app-impact-table-trend-indicator>
                </td>
              </ng-container>
              <ng-container matColumnDef="item-menu">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                  @if (insightPointSelectionState.active || isExpansionPanelShowing) {
                    <ng-container
                      *ngTemplateOutlet="kabobIconTemplate; context: { isDisabled: true }"
                    ></ng-container>
                  } @else {
                    <div
                      [matMenuTriggerFor]="impactMenuTrigger"
                      [matMenuTriggerData]="{ $implicit: element }"
                      (menuOpened)="onOpenImpactMenu(element)"
                    >
                      <ng-container *ngTemplateOutlet="kabobIconTemplate"></ng-container>
                    </div>
                  }

                  <ng-template #kabobIconTemplate let-isDisabled>
                    <xi-icon-button
                      color="CX"
                      buttonSize="small"
                      icon="kabob"
                      [disabled]="isDisabled"
                    ></xi-icon-button>
                  </ng-template>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
          <div
            [matMenuTriggerFor]="menuTrigger"
            #menuTriggerElement="matMenuTrigger"
            class="context-menu-trigger"
          ></div>
        }
      }

      <mat-menu #menuTrigger class="menu-with-xi-icons">
        <ng-template
          matMenuContent
          let-labelDisplay="labelDisplay"
          let-label="label"
          let-column="column"
        >
          <div mat-menu-item class="mat-menu-header" disabled>
            {{ labelDisplay }}
          </div>

          <button
            mat-menu-item
            (click)="
              showDocumentsForItem(
                payload.type === 'focusAreas'
                  ? { entity: label, entityDisplayName: labelDisplay }
                  : null
              )
            "
          >
            <xi-icon icon="preview"></xi-icon>
            <div>{{ t('widgets.show-documents') }}</div>
          </button>

          @if (!isReadOnly && !dashboard.locked) {
            <button mat-menu-item [matMenuTriggerFor]="collectionsMenuTrigger">
              <xi-icon icon="collections"></xi-icon>
              <div>{{ t('widgets.collections') }}</div>
            </button>
          }

          <mat-menu #collectionsMenuTrigger class="menu-with-xi-icons">
            <button
              mat-menu-item
              (click)="
                onOpenSaveDocumentsToCollection('NEW', payload.type === 'focusAreas' ? label : null)
              "
            >
              <xi-icon icon="document"></xi-icon>
              <div>{{ t('widgets.new-collection') }}</div>
            </button>

            <button
              mat-menu-item
              (click)="
                onOpenSaveDocumentsToCollection(
                  'EXISTING',
                  payload.type === 'focusAreas' ? label : null
                )
              "
            >
              <xi-icon icon="add_circle"></xi-icon>
              <div>{{ t('widgets.add-to-collection') }}</div>
            </button>
          </mat-menu>

          @if (
            column !== 'left' &&
            column !== 'right' &&
            !dashboard.locked &&
            payload.type !== 'focusAreas'
          ) {
            <button mat-menu-item (click)="hideImpactItem()">
              <xi-icon icon="remove_circle"></xi-icon>
              <div>{{ t('widgets.hide-item') }}</div>
            </button>
          }
          @if (isSmartSummaryEnabled && !isReadOnly) {
            <div [matTooltip]="interactiveSmartSummaryMenu.tooltip">
              <button
                mat-menu-item
                (click)="openSmartSummary(payload.type === 'focusAreas' ? label : null)"
                [disabled]="!interactiveSmartSummaryMenu.enabled"
              >
                <xi-icon
                  [color]="!interactiveSmartSummaryMenu.enabled ? 'disabled' : 'orca'"
                  icon="lightbulb"
                ></xi-icon>
                <div>{{ interactiveSmartSummaryMenu.label }}</div>
              </button>
            </div>
          }
          @if (isSmartSummaryEnabled && !isReadOnly && pointSummaries?.length > 0) {
            <div [matTooltip]="removeInteractiveSmartSummaryMenu.tooltip">
              <button
                mat-menu-item
                (click)="removeSmartSummary()"
                [disabled]="!removeInteractiveSmartSummaryMenu.enabled"
              >
                <xi-icon
                  [color]="!removeInteractiveSmartSummaryMenu.enabled ? 'disabled' : 'orca'"
                  icon="indeterminate"
                ></xi-icon>
                <div>{{ removeInteractiveSmartSummaryMenu.label }}</div>
              </button>
            </div>
          }
          @if (canAddComment) {
            <div [matTooltip]="commentDialogTooltip()">
              <button
                mat-menu-item
                [disabled]="!canOpenCommentDialog"
                [matMenuTriggerFor]="commentsMenuTrigger"
              >
                <xi-icon
                  [color]="!canOpenCommentDialog ? 'disabled' : 'orca'"
                  icon="comment"
                ></xi-icon>
                <div>{{ t('widgets.comments.comments') }}</div>
              </button>
              <mat-menu #commentsMenuTrigger class="menu-with-xi-icons">
                <div [matTooltip]="addCommentDialogToolTip()">
                  @if (!isReadOnly) {
                    <div>
                      <button mat-menu-item (click)="openCommentDialog()">
                        <xi-icon icon="add_circle"></xi-icon>
                        <div>{{ t('widgets.comments.label-add') }}</div>
                      </button>
                    </div>
                  }
                </div>
                <div [matTooltip]="openCommentDialogToolTip({ label, column })">
                  <button
                    mat-menu-item
                    [disabled]="!hasComment({ label, column })"
                    (click)="onCommentListOpenClicked(itemClicked)"
                  >
                    <xi-icon icon="app_explore"></xi-icon>
                    <div>{{ t('widgets.comments.label-open') }}</div>
                  </button>
                </div>
              </mat-menu>
            </div>
          }
        </ng-template>
      </mat-menu>

      <mat-menu #impactMenuTrigger>
        <ng-template matMenuContent let-element>
          @if (hasActionPlanFeature) {
            <button
              mat-menu-item
              [disabled]="isImpactMenuItemDisabled"
              (click)="onOpenActionPlanDialog(false)"
            >
              {{
                hasActionPlanByRatingField
                  ? t('widgets.open-action-plan')
                  : t('widgets.create-action-plan')
              }}
            </button>
            <button
              mat-menu-item
              [disabled]="
                isImpactMenuItemDisabled || !hasActionPlanByRatingField || !canCreateActionItem
              "
              [matTooltip]="actionItemCreationTooltip"
              (click)="onOpenActionPlanDialog(true)"
            >
              {{ t('widgets.create-action-item') }}
            </button>
          }
        </ng-template>
      </mat-menu>

      <ng-template #comment let-element let-column="column">
        @if (getCellComments(element.label, column); as cellComments) {
          @if (getPinnedComment(cellComments); as pinnedComment) {
            <div
              class="pinned-comment-container"
              appPinnedCommentDrag
              [(comment)]="pinnedComment"
              containerClass="widget-impact__table"
              (isDragging)="disablePinnedCommentClick = $event"
              (click)="onCellCommentIconClicked($event, element, column)"
            >
              <app-comment-compact-card
                #commentCard
                [comment]="pinnedComment"
                [selected]="selectedCommentPointId === pinnedComment.target.pointId"
              ></app-comment-compact-card>
            </div>
          } @else {
            <xi-icon
              icon="comment_filled"
              class="comment-icon"
              [class.selected]="selectedCommentPointId === cellComments[0].target.pointId"
              (click)="
                onCellCommentIconClicked($event, element, column, {
                  columnFilterType: column,
                })
              "
            ></xi-icon>
          }
        }
      </ng-template>

      <ng-template #insightPoint let-element="element" let-column="column">
        @if (element.selectionState?.[column]?.selected) {
          <div class="widget-impact__insight-point-markup">
            <xi-icon icon="lightbulb" iconSize="small" color="CX"></xi-icon>

            <span>{{ element.selectionState[column].index }}</span>
          </div>
        }
      </ng-template>
    }
  </div>
</ng-container>

@if (showDocumentViewModal) {
  <app-lex-xi-modal
    [isVisible]="showDocumentViewModal"
    [canBackdropClose]="false"
    maxWidth="80vw"
    (close)="onDocumentViewModalClosed($event)"
  >
    <ng-template appXIModalContent>
      @if (showDocumentViewModal) {
        <app-document-view-dialog
          [options]="documentViewModalOptions"
          (modalClosed)="onDocumentViewModalClosed($event)"
        ></app-document-view-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
@if (showRatingFieldSelectorModal) {
  <app-lex-xi-modal
    [isVisible]="showRatingFieldSelectorModal"
    [maxWidth]="ratingModalWidth"
    (close)="onRatingFieldSelectorModalClosed(null)"
  >
    <ng-template appXIModalContent>
      <app-rating-field-selector-dialog
        [data]="ratingFieldSelectorData"
        [title]="ratingTitle"
        (modalClosed)="onRatingFieldSelectorModalClosed($event)"
        (widthChange)="handleMaxWidthChange($event)"
      ></app-rating-field-selector-dialog>
    </ng-template>
  </app-lex-xi-modal>
}
@if (showRatingOptionsModal) {
  <app-lex-xi-modal
    [isVisible]="showRatingOptionsModal"
    maxWidth="600px"
    (close)="onRatingOptionsModalClosed(null)"
  >
    <ng-template appXIModalContent>
      <app-predictive-breakdown-drivers-options-dialog
        type="rating"
        [data]="ratingOptionsData"
        (modalClosed)="onRatingOptionsModalClosed($event)"
      ></app-predictive-breakdown-drivers-options-dialog>
    </ng-template>
  </app-lex-xi-modal>
}
@if (showSmartSummaryModal) {
  <app-lex-xi-modal
    [isVisible]="showSmartSummaryModal"
    [canBackdropClose]="false"
    maxWidth="80vw"
    (close)="onSmartSummaryClosed($event)"
  >
    <ng-template appXIModalContent>
      @if (showSmartSummaryModal) {
        <app-interactive-smart-summary
          [options]="interactiveSmartSummaryOptions"
          (modalClosed)="onSmartSummaryClosed($event)"
          (addComment)="onAddSmartSummaryComment($event)"
          (addNotes)="onAddSmartSummaryNotes($event)"
        ></app-interactive-smart-summary>
      }
    </ng-template>
  </app-lex-xi-modal>
}
@if (isActionPlanDialogOpen) {
  <app-lex-xi-modal
    [isVisible]="isActionPlanDialogOpen"
    maxWidth="1200px"
    (close)="onCloseActionPlanDialog()"
  >
    <ng-template appXIModalContent>
      @if (isActionPlanDialogOpen) {
        <app-action-plan-dialog
          [options]="actionPlanDialogOptions"
          (close)="onCloseActionPlanDialog()"
        ></app-action-plan-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
